import { Helmet } from "react-helmet-async";

const SEO = ({ title, description, keywords, canonical }) => {
  const siteName = "The Internal Comms Agency";
  const pageTitle = title ? title + " | " + siteName : siteName;

  return (
    <Helmet
      title={pageTitle}
      meta={[
        description && { name: "description", content: description },
        keywords && { name: "keywords", content: keywords },
        { property: "og:title", content: pageTitle },
        description && { property: "og:description", content: description },
        { name: "twitter:title", content: pageTitle },
        description && { name: "twitter:description", content: description },
      ].filter(Boolean)}
      link={canonical ? [{ rel: "canonical", href: canonical }] : []}
    />
  );
};

export default SEO;
